module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/sad-6d81a4e358694a46b10437a7fe3572b0.svg";